import { render } from "./Collapse.vue?vue&type=template&id=e991a23a&scoped=true&ts=true"
import script from "./Collapse.vue?vue&type=script&lang=ts"
export * from "./Collapse.vue?vue&type=script&lang=ts"

import "./Collapse.vue?vue&type=style&index=0&id=e991a23a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e991a23a"]])

export default __exports__